import { render, staticRenderFns } from "./DueSelector.vue?vue&type=template&id=989d4076"
import script from "./DueSelector.vue?vue&type=script&lang=js"
export * from "./DueSelector.vue?vue&type=script&lang=js"
import style0 from "./DueSelector.vue?vue&type=style&index=0&id=989d4076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports